import { ActionContext, ActionTree, GetterTree, Module, MutationTree } from 'vuex';
import { useToast } from 'vue-toastification';
import { RootState } from '..';
import { PscResult, Payload } from './psc.model';
import pscService from './psc.service';

// namespace
export const PSC_STORE_NAMESPACE = 'pscStore';

// state
interface PscState {
  pscResults: PscResult[];
  status: 'init' | 'idle' | 'loading' | 'failed';
}

const initialState: PscState = {
  pscResults: [],
  status: 'init'
};

// mutation
const mutationConstant = {
  FETCH: 'fetch',
  CLEAR: 'clear',
  PENDING: 'pending',
  FULFILLED: 'fulfilled',
  REJECTED: 'rejected'
};

const mutation: MutationTree<PscState> = {
  [mutationConstant.FETCH]: (state: PscState, pscResults: PscResult[]) => {
    state.pscResults = pscResults;
  },
  [mutationConstant.CLEAR]: (state: PscState) => {
    state.pscResults = [];
  },
  [mutationConstant.PENDING]: (state: PscState) => {
    state.status = 'loading';
  },
  [mutationConstant.FULFILLED]: (state: PscState) => {
    state.status = 'idle';
  },
  [mutationConstant.REJECTED]: (state: PscState) => {
    state.status = 'failed';
    window.location.href = '/';
  },
};

// action
const toast = useToast();
const actionConstant = {
  FETCH: 'fetch',
  CLEAR: 'clear'
};

const action: ActionTree<PscState, RootState> = {
  [actionConstant.FETCH](context: ActionContext<PscState, RootState>, payload: Payload) {
    return new Promise<void>((resolve, reject) => {
      context.commit(mutationConstant.PENDING);
      pscService.Fetch(payload.dateFrom, payload.dateTo)
        .then((response) => {
          context.commit(mutationConstant.FETCH, response.data.returnData.results);
          context.commit(mutationConstant.FULFILLED);
          resolve();
        })
        .catch(() => {
          context.commit(mutationConstant.REJECTED);
          toast.error('ไม่สามารถเรียกข้อมูลได้');
          reject();
        });
    });
  },
  [actionConstant.CLEAR](context: ActionContext<PscState, RootState>) {
    return new Promise<void>((resolve) => {
      context.commit(mutationConstant.PENDING);
      context.commit(mutationConstant.CLEAR);
      context.commit(mutationConstant.FULFILLED);
      resolve();
    });
  },
};

// getter
const getterConstant = {
  ALL: 'all',
  BY_ID: 'byId',
  STATUS: 'status'
};

const getter: GetterTree<PscState, RootState> = {
  [getterConstant.ALL]: (state: PscState) => state.pscResults,
  [getterConstant.BY_ID]: (state: PscState) => (id: string) => state.pscResults.find(m => m.org_id === id),
  [getterConstant.STATUS]: (state: PscState) => state.status,
};

// module
const module: Module<PscState, RootState> = {
  namespaced: true,
  state: initialState,
  mutations: mutation,
  actions: action,
  getters: getter
};

// export
export const PscGetter = {
  ALL: `${PSC_STORE_NAMESPACE}/${getterConstant.ALL}`,
  BY_ID: `${PSC_STORE_NAMESPACE}/${getterConstant.BY_ID}`,
  STATUS: `${PSC_STORE_NAMESPACE}/${getterConstant.STATUS}`
};

export const PscAction = {
  FETCH: `${PSC_STORE_NAMESPACE}/${actionConstant.FETCH}`,
  CLEAR: `${PSC_STORE_NAMESPACE}/${actionConstant.CLEAR}`,
};

export default module;
